"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[96537],{

/***/ 952716:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ Collapse; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(925810);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(994734);
/* harmony import */ var _Flex_Flex_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(387100);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(212951);





function Collapse({
  items = [],
  render,
  max = 3,
  showText,
  hideText
}) {
  const [itemToShow, setItemToShow] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(max);
  const children = render ? items.slice(0, itemToShow).map((item, index) => render(item, index)) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null);
  const showMore = () => setItemToShow(items.length);
  const showLess = () => setItemToShow(max);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", null, children), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Flex_Flex_es_js__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .k, {
    justify: "center"
  }, max >= items.length ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null) : itemToShow < items.length ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledFlexWrapper, {
    align: "center",
    gap: "s4",
    onClick: showMore
  }, showText, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_3__/* .DownOutlined */ .T, {
    size: 14
  })) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledFlexWrapper, {
    align: "center",
    gap: "s4",
    onClick: showLess
  }, hideText, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_4__/* .UpOutlined */ .X, {
    size: 14
  }))));
}
const StyledFlexWrapper = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])(_Flex_Flex_es_js__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .k)`
  cursor: pointer;
  background-color: unset;
  color: #82869e;
  border: 0px;
  &:focus {
    border: 0px;
    outline: 0px;
  }
`;




/***/ }),

/***/ 756097:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ FreeShippingColored; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const FreeShippingColored = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M10.2437 8.8V10.077H10.5287C10.6548 10.077 10.7384 10.0429 10.7939 9.98729C10.8495 9.93171 10.8837 9.84817 10.8837 9.722V9.155C10.8837 9.02883 10.8495 8.94529 10.7939 8.88971C10.7384 8.83413 10.6548 8.8 10.5287 8.8H10.2437Z",
          fill: "#30CD60"
        }
      },
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M5 6C4.44772 6 4 6.44771 4 7V7.74985H0.625014C0.280006 7.74985 0 8.02986 0 8.37486C0 8.71987 0.280006 8.99988 0.625014 8.99988H4V10.2494H1.87453C1.52952 10.2494 1.24951 10.5294 1.24951 10.8744C1.24951 11.2194 1.52952 11.4994 1.87453 11.4994H4V12.75H3.12697C2.78196 12.75 2.50195 13.03 2.50195 13.375C2.50195 13.72 2.78196 14 3.12697 14H4V15C4 15.5523 4.44772 16 5 16L6.00197 16C6.05465 17.3322 7.15515 18.4 8.5 18.4C9.84482 18.4 10.9453 17.3322 10.998 16.0001L16.002 16.0002C16.0547 17.3323 17.1552 18.4 18.5 18.4C19.8448 18.4 20.9452 17.3323 20.998 16.0003L23.3751 16.0003C23.7201 16.0003 24.0002 15.7203 24.0002 15.3753V12.2502C24.0002 12.1365 23.9701 12.0252 23.9114 11.9289L22.0364 8.80388C21.9239 8.61512 21.7201 8.50012 21.5001 8.50012H20V7C20 6.44772 19.5523 6 19 6H5ZM22.6458 12.2499H20V9.74988H21.1458L22.6458 12.2499ZM7.5 15.9C7.5 15.35 7.948 14.9 8.5 14.9C9.052 14.9 9.5 15.35 9.5 15.9C9.5 16.45 9.052 16.9 8.5 16.9C7.948 16.9 7.5 16.45 7.5 15.9ZM18.5 14.9C17.948 14.9 17.5 15.35 17.5 15.9C17.5 16.45 17.948 16.9 18.5 16.9C19.052 16.9 19.5 16.45 19.5 15.9C19.5 15.35 19.052 14.9 18.5 14.9ZM6.30615 7.9H8.57815V8.8H7.24815V10.035H8.29815V10.935H7.24815V13H6.30615V7.9ZM9.30166 7.9H10.5637C10.9398 7.9 11.2496 8.01459 11.4818 8.25169C11.7138 8.48397 11.8257 8.79355 11.8257 9.169V9.708C11.8257 9.94543 11.7786 10.1598 11.6816 10.3487C11.5966 10.5142 11.4795 10.6493 11.3311 10.7527L11.9701 13H10.9908L10.4518 10.977H10.2437V13H9.30166V7.9ZM15.0007 7.9H12.6937V13H15.0007V12.1H13.6357V10.865H14.7207V9.965H13.6357V8.8H15.0007V7.9ZM15.7712 7.9H18.0782V8.8H16.7132V9.965H17.7982V10.865H16.7132V12.1H18.0782V13H15.7712V7.9Z",
          fill: "#30CD60"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 556973:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ PolicyAndService; }
/* harmony export */ });
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(621655);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(952716);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(640128);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(587021);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _i18n_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29921);




var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const PolicyAndService = (_a) => {
  var _b = _a, {
    title,
    information,
    maxPolicyAndService = 5
  } = _b, rest = __objRest(_b, [
    "title",
    "information",
    "maxPolicyAndService"
  ]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadValues({}, rest), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__/* .SubTitle */ .DK, {
    level: 2,
    weight: "medium",
    marginBottom: "s8"
  }, title), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .Collapse */ .U, {
    items: information,
    max: maxPolicyAndService,
    showText: (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_3__.t)("Xem th\xEAm"),
    hideText: (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_3__.t)("R\xFAt g\u1ECDn"),
    render: (item, index) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Policy, {
      key: index
    }, typeof item.icon === "string" ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledIcon, {
      width: 24,
      height: 24,
      src: item.icon
    }) : item.icon, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Content, {
      className: `att-policy-content-${index}`,
      dangerouslySetInnerHTML: {
        __html: item.content
      }
    }))
  }));
};
const Wrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__["default"].div`
  ${_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__/* .CommonStyles */ .F};
  background-color: #fff;
  border-radius: 0.5rem;
`;
const Policy = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__["default"].div`
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  gap: 12px;
`;
const Content = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__["default"].div`
  & > * {
    margin: 0;
  }
`;
const StyledIcon = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__/* .Image */ .E)`
  min-width: 24px;
`;




/***/ }),

/***/ 796537:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Policies": function() { return /* binding */ Policies; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(329944);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(425336);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(756097);
/* harmony import */ var _teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(325710);
/* harmony import */ var _teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(556973);
/* harmony import */ var _teko_types_dist_shared__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(414951);
/* harmony import */ var components_ProductDetail_styles__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(243290);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(316035);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(684443);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(634655);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(891987);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}










const Policies = (param)=>{
    let { wrapperProps , showFreeShip =true  } = param;
    const { product , price , salePolicies , otherPolicies  } = (0,contexts__WEBPACK_IMPORTED_MODULE_3__/* .useProductDetailState */ .W)();
    const provider = product === null || product === void 0 ? void 0 : product.provider;
    const { freeShippingThreshold  } = (0,hooks__WEBPACK_IMPORTED_MODULE_4__/* .useTenantConfig */ .Wx)();
    const shouldShowFreeShip = showFreeShip && typeof freeShippingThreshold === "number" && freeShippingThreshold >= 0 && ((price === null || price === void 0 ? void 0 : price.finalPrice) || 0) >= freeShippingThreshold;
    const renderProviderInfo = ()=>{
        if (!!provider) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_5__/* .SellerCard */ .S, {
                padding: "s16",
                name: provider.name,
                slogan: provider.slogan,
                avatar: {
                    src: provider.logo || ""
                },
                link: {
                    href: "/cua-hang/".concat(provider.id, "?pageTitle=").concat(provider.name)
                }
            });
        }
        return null;
    };
    const renderFreeshipInfo = ()=>{
        if (shouldShowFreeShip) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_ProductDetail_styles__WEBPACK_IMPORTED_MODULE_6__/* .FreeShipping */ .Uv, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_7__/* .FreeShippingColored */ .h, {
                                size: 24,
                                color: "#53c305"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_ProductDetail_styles__WEBPACK_IMPORTED_MODULE_6__/* .ShippingInfo */ .p3, {
                                children: (0,i18n__WEBPACK_IMPORTED_MODULE_8__.t)("Sản phẩm được miễn ph\xed giao h\xe0ng")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__/* .Divider */ .i, {
                        dividerStyle: _teko_types_dist_shared__WEBPACK_IMPORTED_MODULE_1__/* .DividerStyleEnum.dashed */ .fd.dashed,
                        color: "#e0e0e0",
                        gap: "16px"
                    })
                ]
            });
        }
        return null;
    };
    if (!product) {
        return null;
    }
    // render both sale policies and other policies
    if (!provider && !shouldShowFreeShip && !(salePolicies === null || salePolicies === void 0 ? void 0 : salePolicies.length) && !(otherPolicies === null || otherPolicies === void 0 ? void 0 : otherPolicies.length)) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_10__/* .Shape */ .b, _objectSpreadProps(_objectSpread({}, wrapperProps), {
        children: [
            renderProviderInfo(),
            shouldShowFreeShip || (salePolicies === null || salePolicies === void 0 ? void 0 : salePolicies.length) || (otherPolicies === null || otherPolicies === void 0 ? void 0 : otherPolicies.length) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_10__/* .Shape */ .b, {
                backgroundColor: "white",
                borderRadius: "m",
                className: "BOXCARDBODY-RIGHT",
                padding: "s16",
                children: [
                    renderFreeshipInfo(),
                    (salePolicies === null || salePolicies === void 0 ? void 0 : salePolicies.length) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_11__/* .PolicyAndService */ .q, {
                        title: (0,i18n__WEBPACK_IMPORTED_MODULE_8__.t)("Ch\xednh s\xe1ch b\xe1n h\xe0ng"),
                        information: salePolicies,
                        className: "att-product-detail-sale-policies"
                    }) : null,
                    (otherPolicies === null || otherPolicies === void 0 ? void 0 : otherPolicies.length) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_11__/* .PolicyAndService */ .q, {
                        title: (0,i18n__WEBPACK_IMPORTED_MODULE_8__.t)("Dịch vụ kh\xe1c"),
                        information: otherPolicies,
                        marginTop: "s24",
                        className: "att-product-detail-other-services"
                    }) : null
                ]
            }) : null
        ]
    }));
};


/***/ }),

/***/ 606764:
/***/ (function(__unused_webpack_module, exports) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var Variant = /* @__PURE__ */ ((Variant2) => {
  Variant2["primary"] = "primary";
  Variant2["secondary"] = "secondary";
  Variant2["ghost"] = "ghost";
  Variant2["link"] = "link";
  return Variant2;
})(Variant || {});
var Alignment = /* @__PURE__ */ ((Alignment2) => {
  Alignment2["left"] = "left";
  Alignment2["center"] = "center";
  Alignment2["right"] = "right";
  Alignment2["justify"] = "justify";
  return Alignment2;
})(Alignment || {});
var VerticalAlignment = /* @__PURE__ */ ((VerticalAlignment2) => {
  VerticalAlignment2["top"] = "top";
  VerticalAlignment2["center"] = "center";
  VerticalAlignment2["bottom"] = "bottom";
  return VerticalAlignment2;
})(VerticalAlignment || {});
var DSSize = /* @__PURE__ */ ((DSSize2) => {
  DSSize2["small"] = "small";
  DSSize2["medium"] = "medium";
  DSSize2["default"] = "default";
  DSSize2["large"] = "large";
  return DSSize2;
})(DSSize || {});
var DividerTypeEnum = /* @__PURE__ */ ((DividerTypeEnum2) => {
  DividerTypeEnum2["text"] = "text";
  DividerTypeEnum2["icon"] = "icon";
  return DividerTypeEnum2;
})(DividerTypeEnum || {});
var DividerStyleEnum = /* @__PURE__ */ ((DividerStyleEnum2) => {
  DividerStyleEnum2["solid"] = "solid";
  DividerStyleEnum2["double"] = "double";
  DividerStyleEnum2["dotted"] = "dotted";
  DividerStyleEnum2["dashed"] = "dashed";
  return DividerStyleEnum2;
})(DividerStyleEnum || {});

exports.Alignment = Alignment;
exports.DSSize = DSSize;
exports.DividerStyleEnum = DividerStyleEnum;
exports.DividerTypeEnum = DividerTypeEnum;
exports.Variant = Variant;
exports.VerticalAlignment = VerticalAlignment;


/***/ }),

/***/ 414951:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;


__webpack_unused_export__ = ({ value: true });

var _enum = __webpack_require__(606764);



__webpack_unused_export__ = _enum.Alignment;
__webpack_unused_export__ = _enum.DSSize;
exports.fd = _enum.DividerStyleEnum;
__webpack_unused_export__ = _enum.DividerTypeEnum;
__webpack_unused_export__ = _enum.Variant;
__webpack_unused_export__ = _enum.VerticalAlignment;


/***/ })

}]);